import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { merchantService } from 'commons/services';
import { GetBalanceResponse } from 'commons/services/merchantService/merchantService';
import { MoneyObjectInterface } from 'commons/types';

export function useBalance(
  options?: UseQueryOptions<GetBalanceResponse>,
  fetchHasPendingTransfers = false,
) {
  const { isLoading, isError, data } = useQuery<GetBalanceResponse>({
    queryKey: ['balance', fetchHasPendingTransfers],
    queryFn: () => merchantService.getBalance(fetchHasPendingTransfers),
    ...options,
  });

  const defaultMoneyValue: MoneyObjectInterface = { value: 0, currency: '' };
  const waitingFunds = data ? data.waitingFunds : defaultMoneyValue;
  const availableToWithdraw = data
    ? data.availableToWithdraw
    : defaultMoneyValue;

  return {
    isLoading,
    isError,
    data,
    waitingFunds,
    availableToWithdraw,
  };
}
